import { render, staticRenderFns } from "./PendingDocumentSettingsForm.vue?vue&type=template&id=6be6d918"
import script from "./PendingDocumentSettingsForm.vue?vue&type=script&lang=ts"
export * from "./PendingDocumentSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./PendingDocumentSettingsForm.vue?vue&type=style&index=0&id=6be6d918&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports